import { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { Context } from "../context/Context";
import LayoutIndex from "../components/Layout/LayoutIndex";

function PrivateRoute({ component: Component, roles, ...rest }) {
  const { signed, user, userHasTadigRole, mustChangePassword } = useContext(Context);

  // Verifica se o usuario possui alguma ROLE, exigida para a rota.
  function isRoleAllowed(userRoles, routeRoles) {
    if (!userRoles || !routeRoles) return false;
    return userRoles.some((role) => routeRoles.includes(role.name));
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        const currentPath = props.location.pathname;

        if (!signed) {
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          );
        }

        if (signed && (mustChangePassword || !user.lastAccess) && currentPath !== "/profile/password") {
          return (
            <Redirect
              to={{
                pathname: "/profile/password",
                state: {
                  message: "Você está utilizando a senha padrão, é obrigatório alterá-la.",
                  messageType: "info",
                },
              }}
            />
          );
        }

        if (userHasTadigRole) {
          const allowedTadigPaths = ["/ir21/settings/tadigs", "/profile"];
          const isAllowedRoute = allowedTadigPaths.some((path) =>
            currentPath.startsWith(path)
          );

          if (!isAllowedRoute) {
            return (
              <Redirect
                to={{
                  pathname: "/ir21/settings/tadigs",
                  state: { from: props.location },
                }}
              />
            );
          }
        }

        if (roles && !isRoleAllowed(user?.roles, roles)) {
          const redirectPath = userHasTadigRole ? "/ir21/settings/tadigs" : "/";
          return (
            <Redirect
              to={{ pathname: redirectPath, state: { from: props.location } }}
            />
          );
        }

        return (
          <LayoutIndex key="main-layout">
            <Component {...props} />
          </LayoutIndex>
        );
      }}
    />
  );
}

export default PrivateRoute;
